import styled from "styled-components";

export const GridRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  padding: 4px 0;
`;

export const Description = styled.div`
  ont-family: "Aeonik";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.005em;

  margin-top: 8px;
  padding: 8px 0;
  border-top: 1px solid
    ${(props) => props.theme.colors.neutrals.primary.graytext};
  border-bottom: 1px solid
    ${(props) => props.theme.colors.neutrals.primary.graytext};

  color: ${(props) => props.theme.colors.neutrals.primary.graytext};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4px 0;
`;
